import { createSelector } from '@reduxjs/toolkit';
import { selectDetails } from '../../store/selectors';

export const selectMainDetails = createSelector(selectDetails, (details) => details.mainDetails);

export const selectMainDetailsItem = createSelector(selectMainDetails, (mainDetails) => mainDetails.item);
